import * as adActions from './ad.actions';
import {AdItem} from '../ad-item';

export function reducer(adState = [], action: adActions.AdAction): AdItem[] {

  switch (action.type) {

    case adActions.LOAD_ADS_SUCCESS: {
      return action.payload;
    }

    default : {
      return adState;
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/container/adds/store/ad.reducers.ts